import React from "react";
import ThreeDotSvg from "assets/icons/three-dots.svg?react";

function AndroidInstructions() {
  return (
    <div>
      <h2>برای نصب در سیستم عامل اندروید می توانید:</h2>
      <ol>
        <li>
          ۱.در سمت چپ نوار نشانی، روی
          <ThreeDotSvg width={20} height={20} /> «بیشتر» بیشتر ضربه بزنید.
        </li>
        <li>۲.بر روی افزودن به صفحه اصلی ضربه بزنید</li>
        <li>۳.سپس دستورالعمل‌های روی صفحه را دنبال کنید.</li>
      </ol>
    </div>
  );
}

export default AndroidInstructions;
